// src/pages/admin/tabs/collections/CollectionsListPage.jsx
import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { AdminAPI } from '../../../../api/admin';
import { PublicAPI } from '../../../../api/public';

const Wrap = styled.div`display:grid; gap:20px;`;
const Card = styled.div`
  border:1px solid var(--bdr); background:var(--card); border-radius:14px; padding:16px; box-shadow:var(--shadow);
`;
const BlockTitle = styled.h3`margin:0 0 12px;`;
const Actions = styled.div`display:flex; gap:10px; flex-wrap:wrap; align-items:center;`;
const Btn = styled(Link)`
  padding:10px 14px; border-radius:12px; border:1px solid var(--bdr);
  background:var(--card); font-weight:700; cursor:pointer; text-decoration:none;
  &[data-primary="true"]{ background:var(--primary); color:var(--primaryFg); border-color:transparent; }
`;
const Table = styled.table`
  width:100%; border-collapse:collapse;
  th, td{ border-bottom:1px solid var(--bdr); padding:10px 8px; text-align:left; }
  th{ font-weight:700; }
  img{ height:44px; width:72px; object-fit:cover; border-radius:6px; }
`;
const GhostBtn = styled.button`
  padding:8px 10px; border-radius:10px; border:1px solid var(--bdr); background:var(--card); font-weight:700; cursor:pointer;
`;

export default function CollectionsListPage(){
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [regions, setRegions] = React.useState([]);
  const [regionId, setRegionId] = React.useState('');
  const nav = useNavigate();

  const load = React.useCallback(async ()=>{
    setLoading(true);
    try{
      const j = await AdminAPI.listCollections({ region_id: regionId || undefined });
      setItems(j.items || j.collections || []);
    }catch(err){
      console.error(err);
      alert('Не удалось загрузить подборки');
    }finally{ setLoading(false); }
  },[regionId]);

  React.useEffect(()=>{ (async()=>{ try{ const r = await PublicAPI.regions({ locale:'ru' }); setRegions(r?.regions || []);}catch{} })(); }, []);
  React.useEffect(()=>{ load(); }, [load]);

  const del = async (id)=>{
    if(!window.confirm('Удалить подборку? Все связи с объектами будут удалены.')) return;
    try{
      await AdminAPI.deleteCollection(id);
      await load();
    }catch(err){
      console.error(err);
      alert(err?.payload?.details || err?.message || 'Ошибка удаления');
    }
  };

  return (
    <Wrap>
      <Card>
        <Actions>
          <BlockTitle style={{margin:0}}>Подборки</BlockTitle>
          <label style={{display:'inline-flex', alignItems:'center', gap:8}}>
            Регион
            <select value={regionId} onChange={e=>setRegionId(e.target.value)}>
              <option value="">все</option>
              {regions.map(r=> <option key={r.id} value={r.id}>{r.name_ru || r.name_en || r.name || r.slug}</option>)}
            </select>
          </label>
          <div style={{flex:1}} />
          <Btn to="/admin/collections/new" data-primary="true">+ Создать подборку</Btn>
        </Actions>
      </Card>

      <Card>
        <BlockTitle>Список {loading ? '(загрузка...)' : ''}</BlockTitle>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Обложка</th>
              <th>Заголовок</th>
              <th>Slug</th>
              <th>Активна</th>
              <th>Сортировка</th>
              <th>Кол-во объектов</th>
              <th style={{width:220}}></th>
            </tr>
          </thead>
          <tbody>
            {items.map(it=>(
              <tr key={it.id}>
                <td>{it.id}</td>
                <td>{it.cover ? <img src={it.cover} alt="" /> : null}</td>
                <td>{it.title_ru || it.title_en || it.title}</td>
                <td>{it.slug}</td>
                <td>{it.is_active ? 'Да' : 'Нет'}</td>
                <td>{it.sort_order ?? 0}</td>
                <td>{it.items_count ?? it.items_total ?? 0}</td>
                <td style={{display:'flex', gap:8}}>
                  <Btn as={Link} to={`/admin/collections/${it.id}`}>Редактировать</Btn>
                  <GhostBtn onClick={()=>del(it.id)}>Удалить</GhostBtn>
                </td>
              </tr>
            ))}
            {!items.length && !loading && (
              <tr><td colSpan={8} style={{opacity:.7}}>Нет данных</td></tr>
            )}
          </tbody>
        </Table>
      </Card>
    </Wrap>
  );
}
